import './settings.style.scss'

class settingsController {

  // Imports go here
  constructor() {
    'ngInject';
    
  }
}

export default settingsController;



// WEBPACK FOOTER //
// ./ui/src/containers/settings/settings.controller.js